import { createIntl, createIntlCache, IntlShape } from 'react-intl'
import locales, { defaultLocale } from './locales'
import { Locale, parseIntlLocale, parseLocale } from './utils'
import defaultRichTextElements from './richTextElements'

const cache = createIntlCache()

const configI18NTextLocales: Record<string, Record<string, string>> = {}
let intl: IntlShape | undefined = undefined

export const setConfigI18NTexts = (configI18NTexts: ConfigValueI18NText[], defaultLocale: Locale) => {
  configI18NTexts.forEach((configI18NText) => {
    const textLocales = Object.keys(configI18NText.texts) as Locale[]
    textLocales.forEach((langKey) => {
      // eslint-disable-next-line no-prototype-builtins
      if (!configI18NTextLocales.hasOwnProperty(langKey)) configI18NTextLocales[langKey] = {}
      configI18NTextLocales[langKey][configI18NText.textId] = configI18NText.texts[langKey]
    })
  })
  intl = createIntl(
    {
      locale: parseIntlLocale(defaultLocale),
      messages: {
        ...locales.en_GB, //default with en_GB
        ...locales[parseLocale(defaultLocale)], //overwrite with any locale specific texts
        ...configI18NTextLocales['en_GB'], //default with en_GB config texts
        ...configI18NTextLocales[parseLocale(defaultLocale)], //overwrite with any locale specific config texts
      },
      defaultRichTextElements,
    },
    cache
  )
  return intl
}

const getIntl = (requestedLocale?): IntlShape => {
  if (!intl) {
    intl = createIntl(
      {
        locale: parseIntlLocale(defaultLocale),
        messages: {
          ...locales.en_GB,
          ...configI18NTextLocales['en_GB'], //default with en_GB config texts
        },
        defaultRichTextElements,
      },
      cache
    )
  }

  if (intl && requestedLocale && intl.locale !== requestedLocale) {
    intl = createIntl(
      {
        locale: parseIntlLocale(requestedLocale),
        messages: {
          ...locales.en_GB, //default with en_GB
          ...locales[parseLocale(requestedLocale)], //overwrite with any locale specific texts
          ...configI18NTextLocales['en_GB'], //default with en_GB config texts
          ...configI18NTextLocales[parseLocale(requestedLocale)], //overwrite with any locale specific config texts
        },
        defaultRichTextElements,
      },
      cache
    )
  }

  return intl
}

export default getIntl

export const translate = (id?: string, values?: Record<string, any>) => (id ? getIntl().formatMessage({ id }, values) : '')
